import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Divider,
  Segment,
  Menu
} from "semantic-ui-react";
import ReactTable from "react-table";
import request from "../../utils/request";
import matchSorter from 'match-sorter';

export const columns = [
  {
    accessor: d => (
      <div>
        <Button as={Link} to={`/campaigns/${d.id}/summary`} icon="bar chart" primary />
        <Button as={Link} to={`/campaigns/${d.id}/edit`} icon="edit" secondary />
      </div>
    ),
    id: "id",
    Header: "Action",
    filterable: false
  },
  {
    accessor: "title",
    Header: "Title",
    filterMethod: (filter, rows) =>
        matchSorter(rows, filter.value, { threshold: matchSorter.rankings.WORD_STARTS_WITH, keys: ["title"] }),
    filterAll: true
  },
  {
    accessor: "start_at",
    Header: "Start Date",
    filterMethod: (filter, rows) =>
      matchSorter(rows, filter.value, { threshold: matchSorter.rankings.CONTAINS, keys: ["start_at"] }),
    filterAll: true
  },
  {
    accessor: "end_at",
    Header: "End Date",
    filterMethod: (filter, rows) =>
      matchSorter(rows, filter.value, { threshold: matchSorter.rankings.CONTAINS, keys: ["end_at"] }),
    filterAll: true
  },
  {
    accessor: "status",
    Header: "Status",
    filterMethod: (filter, rows) =>
        matchSorter(rows, filter.value, { threshold: matchSorter.rankings.WORD_STARTS_WITH, keys: ["status"] }),
    filterAll: true
  }
];

class CampaignList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isMounted: false,
      isLoading: true,
      sort: [{ id: "id", desc: false }],
      data: [],
      query: "",
      limit: 20,
      page: 0,
      total: 0
    };
  }
  componentDidMount = () => {
    this.setState({ isMounted: true });
    this.fetchData();
  };
  fetchData = e => {
    this.setState({ isLoading: true });
    request
      .get(this, "api:/campaign", {
        sort: this.state.sort,
        q: this.state.query,
        page: this.state.page + 1,
        limit: 0 //this.state.limit
      })
      .then(resp => {
        this.setState({
          isLoading: false,
          data: resp.data,          
        });
      });
  };




  render() {
    const {
      data,
      limit,
      isLoading
    } = this.state;
    return (
      <Segment basic>
        <Menu secondary stackable>
          <Menu.Menu position='right'>
            <Menu.Item>
              <Button
                as={Link}
                to={"/campaigns/create"}
                icon="line graph"
                content="New campaign"
                primary
                fluid
              />
            </Menu.Item>
          </Menu.Menu>
        </Menu>
        <Divider hidden />
        <ReactTable
          data={data}
          columns={columns}
          className="-striped -highlight"                   
          loading={isLoading} // Display the loading overlay when we need it          
          resizable
          filterable
          defaultPageSize={limit}
          minRows={0}                    
        />
      </Segment>
    );
  }
}

export default CampaignList;
